<!--
 * @Description: 可配置场景 20
 * @Date: 2022-06-27 10:50:51
-->
<template>
  <div>
    <el-form
      :model="ruleForm"
      :rules="rules"
      ref="ruleForm"
      label-width="210px"
      class="ruleForm"
    >
      <submit-result
        :auditList="addEditMixin_auditList"
        noPassRemark="请继续编辑项目信息或关联场景"
        :projectStatus="ruleForm.projectStatus"
      ></submit-result>
      <div class="xrk-project-form">
        <div class="left">
          <div>
            <xrk-subtitle>项目信息</xrk-subtitle>
            <el-form-item label="项目编码：" prop="projectName">
              <el-input v-model.trim="ruleForm.projectNo" disabled></el-input>
              <el-button
                type="primary"
                class="copyBtn_1"
                :data-clipboard-text="ruleForm.projectNo"
                @click="$copy('copyBtn_1')"
              >
                复制
              </el-button>
            </el-form-item>
            <el-form-item
              label="客户企业："
              prop="industryEnterpriseId"
              v-if="hasIndustry || penetratingDisplay != -1"
            >
              <el-tooltip
                effect="dark"
                :content="ruleForm.industryEnterpriseName"
                placement="top"
              >
                <el-input
                  disabled
                  :value="ruleForm.industryEnterpriseName"
                  v-if="hasIndustry || penetratingDisplay != -1"
                ></el-input>
              </el-tooltip>
            </el-form-item>
            <el-form-item label="项目名称：" prop="projectName">
              <el-input v-model.trim="ruleForm.projectName" disabled></el-input>
            </el-form-item>
            <el-form-item
              label="项目简介："
              prop="introduction"
              class="absoluteBox"
            >
              <el-input
                type="textarea"
                v-model.trim="ruleForm.introduction"
                placeholder="请输入项目简介"
                :rows="7"
                style="width:300px;"
                maxlength="200"
                :show-word-limit="true"
                :disabled="addEditMixin_introductionDisbaled"
              ></el-input>
            </el-form-item>
            <el-form-item
              label="项目结算单价（不含税）："
              v-if="hasIndustry"
              prop="price"
            >
              <el-input
                :disabled="addEditMixin_disbaled"
                v-model="ruleForm.price"
              ></el-input>
              <span style="margin-left:10px;">元</span>
            </el-form-item>
            <el-form-item label="终端结算单价：" prop="csoPrice">
              <el-input
                :disabled="addEditMixin_disbaled"
                v-model.trim="ruleForm.csoPrice"
                :maxlength="11"
              ></el-input>
              <span style="margin-left:10px;">元</span>
            </el-form-item>
            <el-form-item
              label="税率："
              v-if="hasIndustry"
              prop="contractScale"
            >
              <el-input
                :disabled="addEditMixin_disbaled"
                v-model.trim="ruleForm.contractScale"
              ></el-input>
              <span style="margin-left:10px;">%</span>
              <!-- {{ ruleForm.contractScale | transScale }} -->
            </el-form-item>
            <el-form-item label="总任务量：" prop="taskSumCount">
              <el-input disabled :value="ruleForm.taskSumCount || 0"></el-input>
            </el-form-item>
            <el-form-item label="已完成任务量：">
              <el-input
                disabled
                :value="ruleForm.finishSumCount || 0"
              ></el-input>
            </el-form-item>
            <!-- 项目支付通道 -->
            <PayChannel />
          </div>

          <div style="margin-top:50px">
            <xrk-subtitle>
              项目执行要求
            </xrk-subtitle>

            <el-form-item label="背景需求：" prop="projectBackground">
              <el-select
                v-model="ruleForm.projectBackground"
                :disabled="addEditMixin_disbaled"
                placeholder="请选择背景"
                @change="addEditMixin_validateBackground"
              >
                <el-option
                  v-for="item in addEditMixin_backgroundList"
                  :key="item.id"
                  :value="item.id"
                  :label="item.label"
                ></el-option>
              </el-select>
            </el-form-item>
            <!-- //科室要求： -->
            <template v-if="[2, 3, 6].includes(ruleForm.targetType)">
              <departmentSetting
                v-if="
                  ruleForm.isDeptLimit == 0 ||
                    ruleForm.isDeptLimit == 1 ||
                    ruleForm.isDeptLimit == -1
                "
                :controls="ruleForm.isDeptLimit"
                :projectId="projectId"
                :isImportedPeople="ruleForm.isImportedPeople"
              ></departmentSetting>
            </template>

            <el-form-item label="审核人员对其可见：">
              <reviewer
                :disabled="addEditMixin_disbaled"
                :info="ruleForm"
              ></reviewer>
            </el-form-item>

            <!--1 项目执行人脱敏规则：-->
            <tm-execute-name-rule
              v-model="ruleForm.tmExecuteNameRule"
              :disabled="addEditMixin_disbaled"
            />
            <!--2 目标姓名脱敏规则：-->
            <tm-target-name-rule
              v-model="ruleForm.tmTargetNameRule"
              :ruleForm="ruleForm"
              :disabled="addEditMixin_disbaled"
            />
            <el-form-item
              v-for="(ele, i) in addEditMixin_formItems"
              :label="ele.label"
              :key="i"
              :prop="ele.prop"
              :rules="ele.rule"
            >
              <el-input
                v-model="ruleForm[ele.prop]"
                :disabled="addEditMixin_disbaled"
                v-bind="ele"
              >
                <template #append>
                  {{ ele.suffix }}
                  <el-tooltip placement="top" effect="light">
                    <div slot="content" v-html="ele.content"></div>
                    <i class="el-icon-question"></i>
                  </el-tooltip>
                </template>
              </el-input>
            </el-form-item>
            <el-form-item label="上传图片方式：" prop="picUploadRule">
              <el-checkbox
                style="z-index: 0;"
                v-model="photoRule.photoGraph"
                :disabled="addEditMixin_disbaled"
                label="拍照"
              ></el-checkbox>
              <el-checkbox
                style="z-index: 0;"
                v-model="photoRule.photoLibrary"
                :disabled="addEditMixin_disbaled"
                label="照片图库"
              ></el-checkbox>
            </el-form-item>
            <el-form-item label="职业认证：" prop="isOccupationAuth">
              <el-radio-group
                v-model="ruleForm.isOccupationAuth"
                :disabled="addEditMixin_disbaled"
              >
                <el-radio
                  border
                  class="auth-type"
                  :label="item.type"
                  v-for="(item, index) in isOccupationAuthArray"
                  :key="`way${index}`"
                >
                  {{ item.value }}
                </el-radio>
              </el-radio-group>
            </el-form-item>
            <template v-if="ruleForm.isOccupationAuth">
              <el-form-item label="认证类型：" prop="occupationType">
                <!-- <span>认证类型：</span> -->
                <span>
                  <el-select
                    v-model="ruleForm.occupationType"
                    :disabled="addEditMixin_disbaled"
                    placeholder="请选择认证类型"
                  >
                    <el-option
                      v-for="item in occupationTypeArray"
                      :key="item.id"
                      :value="item.id"
                      :label="item.label"
                    ></el-option>
                  </el-select>
                </span>
              </el-form-item>
              <el-form-item label="认证方式：" prop="occupationAuthMode">
                <el-radio-group
                  v-model="ruleForm.occupationAuthMode"
                  :disabled="addEditMixin_disbaled"
                >
                  <el-radio
                    border
                    :label="item.type"
                    v-for="(item, index) in occupationAuthModeArray"
                    :key="`way${index}`"
                  >
                    {{ item.value }}
                  </el-radio>
                </el-radio-group>
              </el-form-item>
            </template>
            <el-form-item
              label="C端图片查重："
              v-if="addEditMixin_repeatFormItemEnabled"
              prop="isCPicRepeat"
            >
              <el-radio-group
                v-model="ruleForm.isCPicRepeat"
                :disabled="addEditMixin_disbaled"
              >
                <el-radio border class="auth-type" :label="1">
                  是
                </el-radio>
                <el-radio border class="auth-type" :label="0">
                  否
                </el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item
              v-if="holidayIsShow == 1"
              label="是否允许法定节假日执行项目："
              prop="isAllowHoliday"
            >
              <el-switch
                :disabled="addEditMixin_disbaled"
                v-model="ruleForm.isAllowHoliday"
                active-color="#13ce66"
                inactive-color="#ff4949"
                :active-value="1"
                :inactive-value="0"
              ></el-switch>
              <el-tooltip placement="top" effect="light">
                <div slot="content">
                  <span>
                    打开时问卷中时刻题或时间段题可以选择国家法定节假日，关闭时，时刻题或时间段题不能选择国家法定节假日，否则提交任务会被拦截
                  </span>
                </div>
                <i class="el-icon-question"></i>
              </el-tooltip>
            </el-form-item>
            <el-form-item v-if="ruleForm.isSetLocation === 1">
              <div slot="label" class="custom-label">
                是否要求项目
                <br />
                执行人必须
                <br />
                在目标位置定位
              </div>
              <el-switch
                style="margin-top:30px;"
                v-model="ruleForm.isMakeSceneSetLocation"
                active-color="#13ce66"
                inactive-color="#ff4949"
                :active-value="0"
                :inactive-value="1"
                :disabled="addEditMixin_disbaled"
              ></el-switch>
            </el-form-item>
            <!--3 姓名题 -->
            <template v-if="+ruleForm.isQuesNameRule === 1">
              <!-- 输入类型 -->
              <el-form-item label="姓名题输入类型：" prop="tmQuesNameType">
                <el-radio-group
                  v-model="ruleForm.tmQuesNameType"
                  :disabled="addEditMixin_disbaled"
                >
                  <el-radio border :label="1">中文</el-radio>
                  <el-radio border :label="2">英文</el-radio>
                </el-radio-group>
              </el-form-item>
              <!-- 输入规则 -->
              <el-form-item
                v-if="+ruleForm.tmQuesNameType === 1"
                label="姓名题脱敏规则："
                required
                prop="tmQuesNameRule"
              >
                <el-radio-group
                  v-model="tmForm.tmQuesNameRule1"
                  :disabled="addEditMixin_disbaled"
                >
                  <el-radio :label="1" :disabled="addEditMixin_disbaled">
                    部分隐藏
                    <span style="color:rgb(177, 177, 177)">例：王*二</span>
                  </el-radio>
                  <el-radio :label="2" :disabled="addEditMixin_disbaled">
                    字母缩写
                    <span style="color:rgb(177, 177, 177)">例：WZS</span>
                  </el-radio>
                  <el-radio :label="3" :disabled="addEditMixin_disbaled">
                    CRF 四字缩写
                  </el-radio>
                  <el-tooltip
                    effect="dark"
                    placement="top-end"
                    style="transform: translateX(-25px)"
                  >
                    <div slot="content">
                      <p>
                        两字姓名取拼音前2个字母（张三ZHSA）；
                        三字姓名取三字首字母及第三字第二
                      </p>
                      <p>
                        字母（李思思LSSI）；四字姓名取每字首字母（欧阳晓倩OYXQ）；
                        姓名全拼不
                      </p>
                      <p>足4个字母，双写第3个字母（安娥ANEE）</p>
                    </div>
                    <el-button
                      type="text"
                      icon="el-icon-warning-outline"
                    ></el-button>
                  </el-tooltip>
                </el-radio-group>
              </el-form-item>
              <el-form-item
                v-if="+ruleForm.tmQuesNameType === 2"
                label="姓名题脱敏规则："
                required
                prop="tmQuesNameRule"
              >
                <el-radio-group
                  v-model="tmForm.tmQuesNameRule2"
                  :disabled="addEditMixin_disbaled"
                >
                  <el-radio :label="3" :disabled="addEditMixin_disbaled">
                    CRF四字缩写
                  </el-radio>
                  <el-tooltip
                    effect="dark"
                    placement="top-end"
                    style="transform: translateX(-25px);"
                  >
                    <div slot="content">
                      <p>
                        两字姓名取拼音前2个字母（张三ZHSA）；
                        三字姓名取三字首字母及第三字第二
                      </p>
                      <p>
                        字母（李思思LSSI）；四字姓名取每字首字母（欧阳晓倩OYXQ）；
                        姓名全拼不
                      </p>
                      <p>足4个字母，双写第3个字母（安娥ANEE）</p>
                    </div>
                    <el-button
                      type="text"
                      icon="el-icon-warning-outline"
                    ></el-button>
                  </el-tooltip>
                  <el-radio :label="4" :disabled="addEditMixin_disbaled">
                    不处理
                  </el-radio>
                </el-radio-group>
              </el-form-item>
            </template>
            <el-form-item v-if="isOpenPlanRule" label="是否开启智能拜访计划：">
              <el-switch
                :disabled="addEditMixin_disbaled"
                v-model="ruleForm.isOpenPlan"
                active-color="#13ce66"
                inactive-color="#ff4949"
                :active-value="1"
                :inactive-value="0"
              ></el-switch>
              <el-tooltip placement="top" effect="light">
                <div slot="content">
                  <span>开启后系统将会自动为执行者生成拜访计划</span>
                </div>
                <i class="el-icon-question"></i>
              </el-tooltip>
              <div>
                问卷是否默认选中答案：
                <el-radio-group
                  :disabled="addEditMixin_disbaled"
                  v-model="ruleForm.isPlanAnswer"
                >
                  <el-radio :label="1">
                    选中
                  </el-radio>
                  <el-radio :label="0">
                    不选中
                  </el-radio>
                </el-radio-group>
              </div>
            </el-form-item>
            <el-form-item
              label="订单支付审核："
              v-if="ruleForm.isOrderAudit == 1"
            >
              <el-button
                plain
                style="color: #3a8ee6;border-color: #3a8ee6;cursor: default;"
              >
                需审核
              </el-button>
              <span>
                项目支付给自然人时需进行审核
              </span>
            </el-form-item>
            <el-form-item label="是否需要执行人上传资质证明：">
              <el-radio
                :disabled="addEditMixin_disbaled"
                v-model="ruleForm.isNeedCertification"
                :label="1"
              >
                需要
              </el-radio>
              <el-radio
                :disabled="addEditMixin_disbaled"
                v-model="ruleForm.isNeedCertification"
                :label="0"
              >
                不需要
              </el-radio>
            </el-form-item>
            <updateQualificationProof
              :disabled="addEditMixin_disbaled"
              v-model="ruleForm.certificationClassifyList"
              @selectOptionsDataEvent="selectOptionsDataEvent"
              v-if="ruleForm.isNeedCertification === 1"
            ></updateQualificationProof>
          </div>
        </div>

        <div class="right">
          <xrk-subtitle>需求信息</xrk-subtitle>
          <el-form-item label="封面图：" prop="bgUrl">
            <GenerateImage
              :initUrl="ruleForm.bgUrl"
              :oldUrl="ruleForm.oldBgUrl"
              :initType="ruleForm.bgUrlSource"
              @done="addEditMixin_finishUpload"
              @finish="addEditMixin_finishUpload"
              @changeType="addEditMixin_changeBgType"
              :auditStatus="ruleForm.auditStatus"
              :disabled="addEditMixin_disbaled"
            ></GenerateImage>
          </el-form-item>

          <el-form-item :label="`${serviceSubitem}：`">
            <div>
              <el-button
                type="primary"
                @click="toQuestion"
                :disabled="addEditMixin_disbaled || noHasSceneTemplate"
              >
                场景编辑
              </el-button>
            </div>
            <div>
              <el-input
                disabled
                :value="
                  noHasSceneTemplate
                    ? '等待关联场景后可编辑'
                    : `场景标题：${sceneInfo.sceneTitle || ''}`
                "
                placeholder="场景标题"
                style="display:block;margin-top:22px"
              ></el-input>
              <div>
                问卷相似度：
                <span style="color:#67C23A;" v-if="reportValue <= 0.3">
                  低
                </span>
                <span style="color:#E6A23C;" v-else-if="reportValue <= 0.5">
                  中
                </span>
                <span style="color:#EF324E;" v-else-if="reportValue <= 1">
                  高
                </span>
              </div>
            </div>
          </el-form-item>
        </div>
      </div>
      <div class="xrk-project-footer">
        <template v-if="addEditMixin_showSaveBtn">
          <el-button
            type="primary"
            plain
            @click="addEditMixin_submitForm('ruleForm')"
            :loading="btLoading"
            :disabled="addEditMixin_disbaled"
          >
            保存
          </el-button>
          <submit-verify-btn
            :ifDis="noHasSceneTemplate || addEditMixin_disbaled"
            @finish="finishSubmitFn"
            :auditStatus="ruleForm.auditStatus"
          ></submit-verify-btn>
        </template>
        <el-button
          type="primary"
          plain
          v-if="addEditMixin_showAginEditBtn"
          @click="addEditMixin_onAginEditProject(ruleForm)"
          :loading="btLoading"
          :disabled="addEditMixin_aginEditBtnDisabled"
        >
          再次编辑
        </el-button>
        <template v-if="addEditMixin_showAginSaveBtn">
          <el-button
            type="primary"
            plain
            @click="addEditMixin_cancelEditProject('ruleForm')"
          >
            取消
          </el-button>
          <el-button
            type="primary"
            plain
            @click="addEditMixin_confirmEditProject('ruleForm')"
            :loading="btLoading"
          >
            提交审核
          </el-button>
        </template>
        <submit-verify-and-next-btn
          :disabled="noHasSceneTemplate"
          :info="ruleForm"
          :submitFn="finishSubmitFn"
          ref="submitVerifyAndNextBtn"
        ></submit-verify-and-next-btn>
      </div>
    </el-form>
    <el-dialog title="预览" :visible.sync="dialogVisible" width="420px">
      <div class="preview">
        <iframe
          id="iframe"
          :src="ifrSrc"
          frameborder="0"
          scrolling="no"
          v-if="dialogVisible"
          @load="iframeLoad"
          width="375px"
          :height="ifrHeight"
        ></iframe>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">关 闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import {
  company,
  projectV2,
  makeScene,
  checkQuestionnaireIsAlikeAjax
} from '@/api/ajax';
import updateQualificationProof from '../../../update-qualification-proof/update-qualification-proof';
import departmentSetting from '../components/departmentSetting/departmentSetting.vue';
import QRCode from 'qrcode';
import { mapState } from 'vuex';

import Config from '@/config/index';

import addEdit from '@/page/project-classify/src/mixins/add-edit';

import { moneyComplete } from '@/tools/money';

export default {
  name: 'editScene',
  mixins: [addEdit],
  components: { updateQualificationProof, departmentSetting },
  data() {
    const checkUrl = (rule, value, callback) => {
      if (!value) {
        callback(new Error('链接地址不能为空'));
      } else if (!/https:\/\/jinshuju.net/.test(this.ruleForm.jsjUrl)) {
        callback(new Error('链接格式不正确'));
      } else {
        callback();
      }
    };
    return {
      reportValue: 0,

      ifrSrc: '',
      ifrHeight: '800px', // iframe 高度
      dialogVisible: false, // 是否显示预览

      searchAjax: company.list,

      sonProjectName: '',
      photoRule: {
        photoGraph: true,
        photoLibrary: true
      },
      prop: {
        label: 'enterpriseName',
        code: 'id'
      },
      defaultObj: {
        enterpriseName: '',
        id: ''
      },
      dcwjUrlImg: '', // 如果存在 则说明已填写链接
      sceneInfo: {},
      ruleForm: {
        enterpriseName: '',
        industryEnterpriseId: '',
        isOpenPlan: null,
        isPlanAnswer: 0,
        projectNo: '',
        jsjUrl: '',
        isMakeSceneSetLocation: null,
        isMakeSceneSetStartDt: null,
        picUploadRule: 1,
        tmQuesNameType: 0, //姓名题语言类型 1:中文 2:英文
        tmQuesNameRule: 0 //姓名题脱敏规则 1：部分隐藏  2:字母缩写  3:CRF四字缩写  4:不处理 5:四字补齐
      },
      // 脱敏部分，因为 目标姓名脱敏用的同一个值，但需求要分开处理默认值。
      tmForm: {
        tmQuesNameRule1: 0,
        tmQuesNameRule2: 0
      },
      // 校验
      rules: {
        // 项目执行人脱敏
        tmExecuteNameRule: [
          {
            required: true,
            message: '请选择脱敏规则',
            trigger: 'blur',
            validator: (rule, value, callback) => {
              if (+value === 0) {
                callback(new Error('请选择脱敏规则'));
              } else {
                callback();
              }
            }
          }
        ],
        // 目标姓名脱敏规则
        tmTargetNameRule: [
          {
            required: true,
            message: '请选择目标姓名脱敏规则',
            trigger: 'blur',
            validator: (rule, value, callback) => {
              if (+value === 0) {
                callback(new Error('请选择目标姓名脱敏规则'));
              } else {
                callback();
              }
            }
          }
        ],
        // 姓名题类型
        tmQuesNameType: [
          {
            required: true,
            message: '请选择姓名题输入类型',
            trigger: 'blur',
            validator: (rule, value, callback) => {
              if (+value === 0) {
                callback(new Error('请选择姓名题类型'));
              } else {
                callback();
              }
            }
          }
        ],
        // 姓名题脱敏规则
        tmQuesNameRule: [
          {
            required: true,
            message: '请选择姓名题脱敏规则',
            trigger: 'blur',
            validator: (rule, value, callback) => {
              if (+value === 0) {
                callback(new Error('请选择姓名题脱敏规则'));
              } else {
                callback();
              }
            }
          }
        ],
        jsjUrl: [
          {
            required: true,
            validator: checkUrl,
            trigger: 'blur'
          }
        ],
        picUploadRule: [
          {
            required: true,
            message: '请选择上传图片方式',
            trigger: 'blur'
          }
        ],

        industryEnterpriseId: [
          {
            required: true,
            message: '请选择企业',
            trigger: 'blur'
          }
        ]
      }
    };
  },

  methods: {
    finishSubmitFn(type, noAutoReload = false) {
      return new Promise((resolve, reject) => {
        this.$checkQuestionnaireIsAlike({
          projectId: this.projectId,
          projectType: this.projectType,
          callback: isConfirm => {
            if (!isConfirm) {
              //问卷重复弹窗点击取消
              this.$refs.submitVerifyAndNextBtn.loading = false;
              return;
            }
            this.addEditMixin_finishSubmit
              .call(this, type, noAutoReload)
              .then(() => {
                resolve('submit_success');
              })
              .catch(() => {
                reject('submit_error');
              });
          }
        });
      });
    },
    addEditMixin_finishSubmit(type, noAutoReload = false) {
      //审核提交
      return new Promise((resolve, reject) => {
        this.$refs.ruleForm.validate(valid => {
          if (valid) {
            if (this.ruleForm.makeSceneTemplateId) {
              this.$confirm(
                this.hasIndustry
                  ? '请您确认提交当前信息至后台审核，审核通过且待甲方确认无误后您将可以继续执行项目。'
                  : '请您提交当前信息至后台审核，审核通过后您将可以继续执行项目。',
                '提示',
                {
                  confirmButtonText: '确认提交',
                  cancelButtonText: '取消',
                  type: 'warning'
                }
              )
                .then(() => {
                  projectV2
                    .submitProjectAudit({
                      ...this.ruleForm,
                      csoPrice: moneyComplete(this.ruleForm.csoPrice),
                      price: moneyComplete(this.ruleForm.price),
                      type: type
                    })
                    .then(() => {
                      resolve('submit_success');
                      sessionStorage.removeItem(`${this.projectId}-detail`);
                      this.$message({
                        type: 'success',
                        message: '已提交审核',
                        onClose: function() {
                          !noAutoReload && window.location.reload();
                        }
                      });
                    })
                    .catch(() => {
                      reject('submit_error');
                    });
                })
                .catch(() => {
                  reject('submit_error');
                  this.$message({
                    type: 'info',
                    message: '已取消'
                  });
                });
            } else {
              reject('submit_error');
              this.$notify({
                title: '保存失败',
                message: '请先编辑场景内容',
                type: 'error'
              });
            }
          } else {
            reject('submit_error');
            return false;
          }
        });
      });
    },
    toQuestion() {
      /*
        设置缓存，防止点击左侧菜单时重载edit组件
        当项目保存或离开页面时清除缓存
      */
      sessionStorage.setItem(
        `${this.projectId}-detail`,
        JSON.stringify(this.ruleForm)
      );
      this.$router.push({
        name: 'sceneEdit',
        query: {
          ...this.$route.query,
          projectId: this.ruleForm.id,
          projectType: this.ruleForm.projectType
        }
      });
    },
    useqrcode() {
      let canvas = this.$refs.canvas;
      QRCode.toCanvas(canvas, this.dcwjUrlImg, error => {
        if (error) console.error(error);
        this.dcwjUrlImg = canvas.toDataURL('image/png', 1);
      });
    },
    lookewm() {
      this.$alert(
        `<img style='width:255px;height:255px;display:block;margin:auto' src='${this.dcwjUrlImg}' />`,
        ' ',
        {
          dangerouslyUseHTMLString: true,
          closeOnPressEscape: true,
          confirmButtonText: '关 闭',
          showConfirmButton: false,
          closeOnClickModal: true,
          showClose: true
        }
      ).catch(() => {});
    },

    addEditMixin_submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          let cbEvent = () => {
            delete this.ruleForm['certificationClassifyList'];
            projectV2
              .addUpdateProjectV2({
                ...this.ruleForm,
                csoPrice: moneyComplete(this.ruleForm.csoPrice),
                price: moneyComplete(this.ruleForm.price)
              })
              .then(() => {
                this.$notify({
                  title: '成功',
                  message: '保存成功',
                  type: 'success'
                });
                sessionStorage.removeItem(`${this.projectId}-detail`);
                this.$emit('resetRuleForm', this.ruleForm);
                this.resetForm();
              });
          };
          if (this.priceFlag == false) {
            this.makeSureEvent(cbEvent);
          } else {
            cbEvent();
          }
        } else {
          return false;
        }
      });
    },
    iframeLoad() {
      this.$nextTick(() => {
        // let ifrDom = document.getElementById('iframe');
        // setTimeout(() => {
        //   this.ifrHeight =
        //     ifrDom.contentWindow.document.documentElement.scrollHeight + 'px';
        // }, 1500);
      });
    },
    openPreview() {
      this.ifrSrc = this.surveyUrl;
      this.dialogVisible = true;
    }
  },
  computed: {
    ...mapState({
      serviceSubitem: state => state.homeProject.serviceSubitem
    }),
    isOpenPlanRule() {
      const form = this.ruleForm;
      return (
        [11, 10, 15, 6, 2, 16, 3, 12, 9].includes(form.targetType) &&
        form.timeType === 1 &&
        form.isSetTime === 1 &&
        form.isSetTarget === 1 &&
        (form.isSetLocation === 0 ||
          (form.isSetLocation === 1 && form.isMakeSceneSetLocation === 1))
      );
    },
    surveyUrl() {
      return `${window.location.protocol}${Config.webViewUrl}${Config.webPath}/configure?isPreview=2&sceneId=${this.ruleForm.makeSceneBaseId}&platformType=cso`;
    },
    noHasSceneTemplate() {
      return !this.ruleForm.makeSceneTemplateId;
    }
  },
  watch: {
    // 姓名题脱敏 语言类型
    'ruleForm.tmQuesNameType': {
      handler: function(v, oldV) {
        if (+v === +oldV) return;
        if (+oldV === 0) {
          if (+v === 1) {
            if (![1, 2, 3, 4].includes(+this.ruleForm.tmQuesNameRule)) {
              this.tmForm.tmQuesNameRule1 = 1;
              this.ruleForm.tmQuesNameRule = 1;
            }
          }
          if (+v === 2) {
            if (![3, 4].includes(+this.ruleForm.tmQuesNameRule)) {
              this.tmForm.tmQuesNameRule2 = 4;
              this.ruleForm.tmQuesNameRule = 4;
            }
          }
        } else {
          if (+v === 1) {
            this.tmForm.tmQuesNameRule1 = 1;
            this.ruleForm.tmQuesNameRule = 1;
          }
          if (+v === 2) {
            this.tmForm.tmQuesNameRule2 = 4;
            this.ruleForm.tmQuesNameRule = 4;
          }
        }
      }
    },
    //姓名题 中文脱敏规则
    'tmForm.tmQuesNameRule1': {
      handler: function(v) {
        this.ruleForm.tmQuesNameRule = v;
      }
    },
    //姓名题 英文脱敏规则
    'tmForm.tmQuesNameRule2': {
      handler: function(v) {
        this.ruleForm.tmQuesNameRule = v;
      }
    },
    'ruleForm.isQuesNameRule': {
      handler: function(v) {
        if (+v === 0) {
          this.ruleForm.tmQuesNameRule = 0;
          this.ruleForm.tmQuesNameType = 0;
        }
      }
    },
    photoRule: {
      handler(v) {
        let pickUpload = null;
        //全选
        if (v.photoGraph && v.photoLibrary) {
          pickUpload = 1;
        }
        //拍照
        if (v.photoGraph && !v.photoLibrary) {
          pickUpload = 2;
        }
        //图库
        if (!v.photoGraph && v.photoLibrary) {
          pickUpload = 3;
        }
        this.ruleForm.picUploadRule = pickUpload;
      },
      deep: true
    },
    'ruleForm.picUploadRule': {
      handler(v) {
        if (+v === 1) {
          this.photoRule.photoGraph = true;
          this.photoRule.photoLibrary = true;
        }
        if (+v === 2) {
          this.photoRule.photoGraph = true;
          this.photoRule.photoLibrary = false;
        }
        if (+v === 3) {
          this.photoRule.photoGraph = false;
          this.photoRule.photoLibrary = true;
        }
      },
      deep: true
    },
    //如果拜访目标为患者则姓名脱敏规则强制为字母缩写并禁用
    'ruleForm.szVisitType': {
      handler(v) {
        // this.ruleForm.tmTargetNameRule = 1;
        if (+v === 13) {
          // this.ruleForm.tmTargetNameRule = 4;
          // this.ruleForm.projectDesensitizationRule = 1;
        }
      }
    }
  },
  async created() {
    window.onmessage = ({ data }) => {
      if (data && data.code === 'iframeHeight' && data.value) {
        this.ifrHeight = `${data.value}px`;
      }
    };

    const data = await this.addEditMixin_init();
    let {
      tXcxProject,
      tDoctorProject,
      sonProjectName,
      taskSumCount,
      finishSumCount
    } = data;
    this.ruleForm.isNeedCertification = this.homeProject.isNeedCertification;
    this.ruleForm.certificationClassifyList = this.homeProject.certificationClassifyList;
    this.sonProjectName = sonProjectName == '全部' ? '' : sonProjectName;
    let project = tXcxProject || tDoctorProject;
    const {
      isMakeSceneSetLocation,
      isMakeSceneSetStartDt,
      isOpenPlan,
      isPlanAnswer
    } = project;
    try {
      this.ruleForm.isMakeSceneSetLocation = parseInt(
        isMakeSceneSetLocation === null ? 1 : isMakeSceneSetLocation || '0'
      );
      this.ruleForm.isMakeSceneSetStartDt = parseInt(
        isMakeSceneSetStartDt === null ? 1 : isMakeSceneSetStartDt || '0'
      );

      this.ruleForm.isPlanAnswer = parseInt(
        isPlanAnswer === null ? 0 : isPlanAnswer || '0'
      );
      delete project.isOpenPlan;
      delete project.isPlanAnswer;
      delete project.isMakeSceneSetLocation;
      delete project.isMakeSceneSetStartDt;
    } catch (err) {
      console.error(err);
    }
    // 如果 有姓名题脱敏规则
    if (+project.isQuesNameRule !== 0) {
      // 没有值 设置默认值
      if (+project.tmQuesNameType === 0) {
        this.tmForm.tmQuesNameRule1 = 1; // 部分隐藏
        project.tmQuesNameType = 1; // 类型中文
        project.tmQuesNameRule = 1; // 部分隐藏
      } else {
        // 有值 分别赋值给 组件绑定的值
        if (+project.tmQuesNameType === 1) {
          // 中文
          this.tmForm.tmQuesNameRule1 = project.tmQuesNameRule;
        }
        if (+project.tmQuesNameType === 2) {
          // 英文
          this.tmForm.tmQuesNameRule2 = project.tmQuesNameRule;
        }
      }
    }

    Object.assign(this.ruleForm, project);
    this.ruleForm = Object.assign({}, this.ruleForm, {
      taskSumCount,
      finishSumCount
    });
    this.ruleForm.picUploadRule = this.ruleForm.picUploadRule || 1;

    this.dcwjUrlImg = project.jsjUrl;
    if (project.jsjUrl) {
      this.$nextTick(() => {
        this.useqrcode();
      });
    }
    this.ruleForm.isOpenPlan = parseInt(
      isOpenPlan === null ? (this.isOpenPlanRule ? 1 : '0') : isOpenPlan
    );
    try {
      const makeSceneInfoData = await makeScene.makeSceneInfoByProject({
        projectId: this.projectId,
        projectType: 20
      });
      this.sceneInfo = ((makeSceneInfoData || {}).data || {}).data;
      checkQuestionnaireIsAlikeAjax({
        projectId: this.projectId,
        projectType: this.projectType
      }).then(({ data: { data } }) => {
        this.reportValue = data;
      });
    } catch (err) {
      console.error(err);
    }
    const noCacheData = {
      tmQuesNameType: project.tmQuesNameType,
      tmQuesNameRule: project.tmQuesNameRule,
      isQuesNameRule: project.isQuesNameRule
    };

    this.$emit('resetRuleForm', this.ruleForm);
    /*
            当点击编辑问卷时设置缓存
            优先使用缓存，离开页面或保存后清除
          */
    if (sessionStorage.getItem(`${this.projectId}-detail`)) {
      const cacheData = JSON.parse(
        sessionStorage.getItem(`${this.projectId}-detail`)
      );
      delete cacheData.tmQuesNameType;
      delete cacheData.isQuesNameRule;
      this.ruleForm = {
        ...cacheData
      };
      sessionStorage.clear();
      // 设置问卷ID，解决第一次编辑项目时，再编辑问卷后sessionStorage中不存在问卷ID
      this.ruleForm.questionnaireId = tXcxProject.questionnaireId;
    }
    this.ruleForm = {
      ...this.ruleForm,
      ...noCacheData
    };
  }
};
</script>
<style lang="scss" scoped>
>>> .el-radio-group {
  display: flex;
  align-items: center;
}

#canvas {
  display: none;
  width: 255px;
  height: 255px;
}

.preview {
  width: 375px;
  height: 550px;
  overflow-y: auto;
  overflow-x: hidden;
  margin: auto;
}

.custom-label {
  line-height: 1.75;
  position: relative;
  padding-right: 15px;

  &::after {
    content: '：';
    position: absolute;
    right: -2px;
    top: 50%;
    transform: translateY(-50%);
  }
}
</style>
